import { TestItemDetailDialog } from '../../0_presentation/test/components/testDialogs';
import useDialog from '../core/components/feedback/useDialog';

const useTestDetailDialogController = () => {
  const dialog = useDialog();

  const openDetailDialog = (itemCode: Serial) => {
    dialog.openDialog(
      <TestItemDetailDialog
        itemCode={itemCode}
        onConfirm={dialog.closeDialog}
      ></TestItemDetailDialog>
    );
  };

  return {
    openDetailDialog,
  };
};

export default useTestDetailDialogController;
